"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignaExDirisEffectHandler = exports.SignaExDirisEffectArgs = void 0;
const EventType_1 = require("../../events/EventType");
const Schedule_1 = require("../../Schedule");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class SignaExDirisEffectArgs {
    constructor(rolls = 6) {
        this.rolls = rolls;
        this.__type = EffectType_1.EffectType.SignaExDiris;
        this.__typeName = "SignaExDiris";
        this.name = "SignaExDiris";
        this.harmful = true;
    }
}
exports.SignaExDirisEffectArgs = SignaExDirisEffectArgs;
let SignaExDirisEffectHandler = class SignaExDirisEffectHandler {
    apply(sequence, container, state) {
        state.meta.eventHandlerIds = state.meta.eventHandlerIds || [];
        for (let i = 0; i < state.args.rolls; i++) {
            container.registerEventHandlerScript(state.targetId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Combined(i + 1, 1), "Effect_SignaExDiris_OnTurnStarted", {
                effectId: state.id
            });
        }
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        (state.meta.eventHandlerIds || []).forEach(ehId => container.cancelEventHandler(ehId));
        ;
        (state.meta.effectIds || []).forEach(eId => container.cancelEffect(sequence, eId));
    }
};
SignaExDirisEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.SignaExDiris)
], SignaExDirisEffectHandler);
exports.SignaExDirisEffectHandler = SignaExDirisEffectHandler;
